export default __webpack_public_path__ + "static/media/ic-part-test.b88638b7.svg";